<div class="tf-save-to-list-modal-window-ctnr">

    <div (click)="closeModal()" class="modal-close-ctnr">
        <svg viewBox="0 0 10 10">
            <line x1="1" y1="1" x2="9" y2="9"/>
            <line x1="1" y1="9" x2="9" y2="1"/>
        </svg>
    </div>

    <div class="save-to-list-modal-header-ctnr">
        <div class="save-to-list-modal-header">
            About shared lists
        </div>
        <div class="save-to-list-modal-content">
            Shared lists are a new way to save products.
            Create a list for each of your projects to share
            with collaborators like your lab manager.
            Then select and buy products as a team.
        </div>
    </div>

    <div class="save-to-list-modal-body">
        <div class="save-to-list-item">
            <svg class="icon-save-to-list icon-material" viewBox="0 0 131 65">
                <g fill="none" fill-rule="evenodd" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M39.209 16v4.292l6.628 4.952s4.639 2.642 4.639 4.623V59.58s-.994 2.971-2.65 2.971H20.65c-1.656 0-2.65-2.971-2.65-2.971V29.867c0-1.981 4.639-4.623 4.639-4.623l6.628-4.952V16h9.942zM28 15.623h12.28V11H28z"/>
                    <path d="M30 20h9.362"/>
                    <path stroke-linecap="round" stroke-linejoin="round"
                          d="M1 59.414C1 60.837 2.125 62 3.5 62S6 60.837 6 59.414V35H1v24.414zM1 30h5v5H1zM62 63.543h64.242V11H62z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" d="M59 11.436h70.029V1H59z"/>
                    <path d="M93 11v51.984"/>
                </g>
            </svg>
            <div class="save-to-list-item-heading">Creating a shared list</div>
            <div class="save-to-list-item-body">
                Click "Save to list" to create your first list, give it a name, and add the product. Access your shared
                lists in the Account link on Thermofisher.com.
            </div>
        </div>
        <div class="save-to-list-item">
            <svg class="icon-save-to-list icon-colaborate" viewBox="0 0 121 91">
                <g fill="none" fill-rule="evenodd">
                    <path stroke-width="2"
                          d="M36.637 33.344c0 6.673-5.406 12.083-12.075 12.083-6.668 0-12.074-5.41-12.074-12.083 0-6.674 5.406-12.083 12.074-12.083 6.67 0 12.075 5.41 12.075 12.083z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M1.052 69.04c0-12.992 10.526-23.525 23.51-23.525 12.985 0 23.51 10.533 23.51 23.526"/>
                    <path stroke-width="2"
                          d="M108.455 33.344c0 6.673-5.406 12.083-12.075 12.083s-12.075-5.41-12.075-12.083c0-6.674 5.406-12.083 12.075-12.083s12.075 5.41 12.075 12.083z"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M72.87 69.04c0-12.992 10.525-23.525 23.51-23.525 12.985 0 23.51 10.533 23.51 23.526M37.323 78.266c7.118 7.218 17.002 11.698 27.937 11.698 11.322 0 21.518-4.803 28.684-12.477"/>
                    <path d="M38.758 85.608a.45.45 0 0 0 .333-.542l-1.593-6.684 6.727 1.382a.45.45 0 0 0 .18-.88l-7.417-1.524a.448.448 0 0 0-.527.545l1.756 7.37a.451.451 0 0 0 .541.333"/>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M93.196 12.75C86.078 5.531 76.194 1.051 65.259 1.051c-11.322 0-21.518 4.803-28.684 12.476"/>
                    <path d="M91.76 5.408a.45.45 0 0 0-.332.542l1.593 6.684-6.727-1.383a.45.45 0 0 0-.181.88l7.417 1.524a.448.448 0 0 0 .527-.544l-1.756-7.37a.451.451 0 0 0-.54-.333"/>
                </g>
            </svg>
            <div class="save-to-list-item-heading">Collaborate</div>
            <div class="save-to-list-item-body">
                You can invite collaborators like your lab manager or procurement staff to any shared list. They can add
                more items, leave comments and complete the final purchase.
            </div>
        </div>

        <div class="save-to-list-item">
            <svg class="icon-save-to-list icon-export" viewBox="0 0 84 72">
                <g fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <g>
                        <path d="M48.532 51.427L81.975 51.427 81.975.746.028.746.028 51.427 33.472 51.427M41 42.79v27.368M50.577 60.728L41.002 70.277 31.427 60.728"
                              transform="translate(1) translate(0 .308)"/>
                    </g>
                    <path d="M27.838 42.729L54.168 42.729 54.168 10.122 27.838 10.122zM35 17h12.609M35 23h12.609M35 29h12.609M35 35h12.609"
                          transform="translate(1)"/>
                </g>
            </svg>
            <div class="save-to-list-item-heading">Export as a spreadsheet</div>
            <div class="save-to-list-item-body">
                Export your list as a spreadsheet for easy documentation or hand off to your lab&apos;s designated
                buyer.
            </div>
        </div>
    </div>

    <div class="save-to-list-bullets-ctnr">
        <span class="bullet"></span>
        <span class="bullet"></span>
        <span class="bullet"></span>
    </div>
</div>